import { SBoolean, SNumber, SString } from '@/common/model';

const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const getIdFromTime = ():string =>{
    // 获取当前的纳秒时间
    let nanoTime = process.hrtime.bigint();
    let result = '';
    for (let i = 0; i < 4; i++) {
        const index = nanoTime % BigInt(chars.length);
        result = chars[Number(index)] + result;
        nanoTime = BigInt(Math.floor(Number(nanoTime / BigInt(chars.length))));
    }
    return result;
} 

const stringCompareTo =  (a:SString, b:SString):number=>{
  if(a == b){
    return 0;
  }
  if(a && !b){
    return 1
  }
  else if (!a&&b){
    return -1;
  }
  if(a!=null && b != null){
    return a.localeCompare(a, b)
  }
  return 0;
}

const numberCompareTo =  (a:SNumber, b:SNumber):number=>{
  if(a == b){
    return 0;
  }
  if(a && !b){
    return 1
  }
  else if (!a&&b){
    return -1;
  }
  
  if(a!=null && b != null){
    return a - b;
  } 
  return 0;
}

const booleanCompareTo =  (a:SBoolean, b:SBoolean):number=>{
  if(a == b){
    return 0;
  }
  if(a && !b){
    return 1
  }
  else{
    return -1;
  }
}


export const Util = {
    getIdFromTime,
    stringCompareTo,
    numberCompareTo,
    booleanCompareTo
}